export default __webpack_public_path__ + "static/media/logoIC.a865576b.svg";